import { PLAY_STORE_URL } from '../../constants/links';

type PlayStoreButtonProps = {
  url?: string;
  className?: string;
};

export default function PlayStoreButton({
  url = PLAY_STORE_URL,
  className = '',
}: PlayStoreButtonProps) {
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className={`flex items-center justify-center gap-3 px-8.5 py-3.5 bg-black text-white rounded-lg font-semibold hover:bg-gray-900 shadow-lg hover:shadow-xl transition-all ${className}`}>
      <svg
        className="w-11 h-11"
        viewBox="0 0 24 24"
        fill="currentColor">
        <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" />
      </svg>
      <div className="flex flex-col items-start">
        <span className="text-base leading-tight">Get it on</span>
        <span className="text-lg leading-tight">Google Play</span>
      </div>
    </a>
  );
}

